import { atom } from "recoil";

const answersAtom = atom({
  key: 'answers',
  default: {
    answers: null,
    loading: false,
  }
});

export { answersAtom };